import React from 'react';
import './SkeletonLoader.css';

/**
 * Skeleton Loader Component
 * Provides visual feedback while data is loading
 */
const SkeletonLoader = ({
  type = 'card',
  count = 1,
  height = '20px',
  width = '100%',
  className = ''
}) => {
  if (type === 'card') {
    return (
      <div className={`skeleton-card ${className}`}>
        <div className="skeleton-header">
          <div className="skeleton-title"></div>
          <div className="skeleton-subtitle"></div>
        </div>
        <div className="skeleton-body">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="skeleton-line"></div>
          ))}
        </div>
      </div>
    );
  }

  if (type === 'table') {
    return (
      <div className={`skeleton-table ${className}`}>
        <div className="skeleton-table-row skeleton-table-header">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="skeleton-table-cell skeleton-title"></div>
          ))}
        </div>
        {Array.from({ length: count }).map((_, rowIdx) => (
          <div key={rowIdx} className="skeleton-table-row">
            {Array.from({ length: 4 }).map((_, colIdx) => (
              <div key={colIdx} className="skeleton-table-cell skeleton-line"></div>
            ))}
          </div>
        ))}
      </div>
    );
  }

  if (type === 'chart') {
    return (
      <div className={`skeleton-chart ${className}`}>
        <div className="skeleton-chart-bar"></div>
        <div className="skeleton-chart-bar"></div>
        <div className="skeleton-chart-bar"></div>
      </div>
    );
  }

  if (type === 'line') {
    return (
      <div
        className={`skeleton-line ${className}`}
        style={{ height, width }}
      ></div>
    );
  }

  return Array.from({ length: count }).map((_, i) => (
    <div
      key={i}
      className={`skeleton-line ${className}`}
      style={{ height, width, marginBottom: i < count - 1 ? '8px' : '0' }}
    ></div>
  ));
};

export default SkeletonLoader;



// WEBPACK FOOTER //
// ./src/shared/components/SkeletonLoader/index.js